<template>
  <DecisionDialog
    @cancel="emit('deny')"
    @confirm="emit('approve')"
    ref="decisionDialogRef"
    :content="dialogContent"
    :processing="processing"
    cancel-button-text="Deny"
    confirm-button-text="Approve"
    title="Review attachment"
  />
</template>

<script setup>
import DecisionDialog from '@/shared/components/DecisionDialog.vue';

const props = defineProps({
  categoryName: {
    type: String,
    default: null,
  },
  openOnMount: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['approve', 'close', 'deny']);

const decisionDialogRef = ref(null);

const dialogContent = computed(() => {
  if (props.categoryName) {
    return `Do you want to approve or deny the ${props.categoryName} attachment?`;
  }

  return 'Do you want to approve or deny this attachment?';
});

onMounted(load);

async function load() {
  if (!props.openOnMount) return;

  await nextTick();
  decisionDialogRef.value?.open();
}

function open() {
  decisionDialogRef.value?.open();
}

function close() {
  decisionDialogRef.value?.close();
  emit('close');
}

defineExpose({ close, open });
</script>
